import React, { useState } from "react";
import { Image } from "react-bootstrap"; // Note: Ensure you have this component if using images this way.
import { useNavigate } from "react-router-dom";

export default function SearchBarMobile({closeDropdown }) {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    navigate(`/products?keyword=${keyword.trim()}`);
  };

  return (
    <form
      onSubmit={submitHandler}
      className="flex items-center space-x-2 w-full"
    >
      <input
        type="search"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="Enter Product Name ..."
        name="keyword"
        className="flex-grow p-2 text-sm text-black rounded-md border-2 border-gray-300 focus:border-blue-500 focus:outline-none"
      />
      <button
        className="p-2 bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
        type="submit"
        onClick={closeDropdown}
      >
        <Image src="/img/search.png" alt="Search" className="w-5 h-5" />
      </button>
    </form>
  );
}
